var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center h-full border border-solid border-darkGray hover:opacity-70",attrs:{"aria-label":_vm.direction === 'right' ? 'Slide Right' : 'Slide Left'},on:{"click":function($event){return _vm.$emit('click')}}},[_c('ArrowLongIcon',{staticClass:"w-4 h-4 fill-black",class:[_vm.getIconDirection]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }